import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/icn-question.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-2da1ecd6")

_pushScopeId("data-v-2da1ecd6")
const _hoisted_1 = { class: "fridgesettings-page" }
const _hoisted_2 = {
  key: 0,
  ref: "scroll",
  class: "fridgesettings-page-content"
}
const _hoisted_3 = { class: "fridgesettings-page-content-content" }
const _hoisted_4 = {
  key: 0,
  class: "fridgesettings-page-content-content-partialchilled"
}
const _hoisted_5 = { class: "fridgesettings-page-content-content-partialchilled-change" }
const _hoisted_6 = { class: "fridgesettings-page-content-content-partialchilled-change-title" }
const _hoisted_7 = { class: "fridgesettings-page-content-content-partialchilled-change-title-title" }
const _hoisted_8 = { class: "fridgesettings-page-content-content-partialchilled-change-title-title-text" }
const _hoisted_9 = /*#__PURE__*/_createVNode("img", {
  class: "fridgesettings-page-content-content-partialchilled-change-title-button-image",
  src: _imports_0
}, null, -1)
const _hoisted_10 = { class: "fridgesettings-page-content-content-partialchilled-change-radiobutton" }
const _hoisted_11 = { class: "fridgesettings-page-content-content-radiobutton" }
const _hoisted_12 = { class: "fridgesettings-page-content-content-radiobutton-description" }
const _hoisted_13 = { class: "fridgesettings-page-content-content-radiobutton-description-title" }
const _hoisted_14 = { class: "fridgesettings-page-content-content-radiobutton-description-title-text" }
const _hoisted_15 = {
  key: 1,
  class: "fridgesettings-page-content-content-partialhalf"
}
const _hoisted_16 = { class: "fridgesettings-page-content-content-partialhalf-title" }
const _hoisted_17 = { class: "fridgesettings-page-content-content-partialhalf-title-title" }
const _hoisted_18 = { class: "fridgesettings-page-content-content-partialhalf-title-title-text" }
const _hoisted_19 = /*#__PURE__*/_createVNode("img", {
  class: "fridgesettings-page-content-content-partialhalf-title-button-image",
  src: _imports_0
}, null, -1)
const _hoisted_20 = { class: "fridgesettings-page-content-content-partialhalf-value" }
const _hoisted_21 = /*#__PURE__*/_createVNode("div", { class: "fridgesettings-page-content-content-partialhalf-value-spacer" }, null, -1)
const _hoisted_22 = { class: "fridgesettings-page-content-content-partialhalf-value-hour" }
const _hoisted_23 = { class: "fridgesettings-page-content-content-partialhalf-value-hour-title" }
const _hoisted_24 = { class: "fridgesettings-page-content-content-partialhalf-value-hour-title-text" }
const _hoisted_25 = { class: "fridgesettings-page-content-content-partialhalf-value-hour-subtitle" }
const _hoisted_26 = { class: "fridgesettings-page-content-content-partialhalf-value-hour-subtitle-text" }
const _hoisted_27 = { class: "fridgesettings-page-content-content-partialhalf-value-hour-switch" }
const _hoisted_28 = /*#__PURE__*/_createVNode("div", { class: "fridgesettings-page-content-content-partialhalf-value-spacer" }, null, -1)
const _hoisted_29 = { class: "fridgesettings-page-content-content-partialhalf-value-hour" }
const _hoisted_30 = { class: "fridgesettings-page-content-content-partialhalf-value-hour-title" }
const _hoisted_31 = { class: "fridgesettings-page-content-content-partialhalf-value-hour-title-text" }
const _hoisted_32 = { class: "fridgesettings-page-content-content-partialhalf-value-hour-subtitle" }
const _hoisted_33 = { class: "fridgesettings-page-content-content-partialhalf-value-hour-subtitle-text" }
const _hoisted_34 = { class: "fridgesettings-page-content-content-partialhalf-value-hour-switch" }
const _hoisted_35 = /*#__PURE__*/_createVNode("div", { class: "fridgesettings-page-content-content-partialhalf-value-spacer" }, null, -1)
const _hoisted_36 = { class: "fridgesettings-page-content-content-radiobutton" }
const _hoisted_37 = { class: "fridgesettings-page-content-content-radiobutton-description" }
const _hoisted_38 = { class: "fridgesettings-page-content-content-radiobutton-description-title" }
const _hoisted_39 = { class: "fridgesettings-page-content-content-radiobutton-description-title-text" }
const _hoisted_40 = /*#__PURE__*/_createVNode("img", {
  class: "fridgesettings-page-content-content-radiobutton-description-button-image",
  src: _imports_0
}, null, -1)
const _hoisted_41 = { class: "fridgesettings-page-content-content-radiobutton" }
const _hoisted_42 = { class: "fridgesettings-page-content-content-radiobutton-description" }
const _hoisted_43 = { class: "fridgesettings-page-content-content-radiobutton-description-title" }
const _hoisted_44 = { class: "fridgesettings-page-content-content-radiobutton-description-title-text" }
const _hoisted_45 = /*#__PURE__*/_createVNode("img", {
  class: "fridgesettings-page-content-content-radiobutton-description-button-image",
  src: _imports_0
}, null, -1)
const _hoisted_46 = {
  key: 2,
  class: "fridgesettings-page-content-content-switch"
}
const _hoisted_47 = { class: "fridgesettings-page-content-content-switch-description" }
const _hoisted_48 = { class: "fridgesettings-page-content-content-switch-description-title" }
const _hoisted_49 = { class: "fridgesettings-page-content-content-switch-description-title-text" }
const _hoisted_50 = /*#__PURE__*/_createVNode("img", {
  class: "fridgesettings-page-content-content-switch-description-button-image",
  src: _imports_0
}, null, -1)
const _hoisted_51 = { class: "fridgesettings-page-content-content-switch-description-note" }
const _hoisted_52 = { class: "fridgesettings-page-content-content-switch-description-note-text" }
const _hoisted_53 = {
  key: 3,
  class: "fridgesettings-page-content-content-partialfrozen"
}
const _hoisted_54 = { class: "fridgesettings-page-content-content-partialfrozen-change" }
const _hoisted_55 = { class: "fridgesettings-page-content-content-partialfrozen-change-title" }
const _hoisted_56 = { class: "fridgesettings-page-content-content-partialfrozen-change-title-title" }
const _hoisted_57 = { class: "fridgesettings-page-content-content-partialfrozen-change-title-title-text" }
const _hoisted_58 = /*#__PURE__*/_createVNode("img", {
  class: "fridgesettings-page-content-content-partialfrozen-change-title-button-image",
  src: _imports_0
}, null, -1)
const _hoisted_59 = { class: "fridgesettings-page-content-content-partialfrozen-change-radiobutton" }
const _hoisted_60 = { class: "fridgesettings-page-content-content-radiobutton" }
const _hoisted_61 = { class: "fridgesettings-page-content-content-radiobutton-description" }
const _hoisted_62 = { class: "fridgesettings-page-content-content-radiobutton-description-title" }
const _hoisted_63 = { class: "fridgesettings-page-content-content-radiobutton-description-title-text" }
const _hoisted_64 = {
  key: 4,
  class: "fridgesettings-page-content-content-radiobutton fridgesettings-page-content-content-radiobutton-coolingAssist"
}
const _hoisted_65 = { class: "fridgesettings-page-content-content-radiobutton-description" }
const _hoisted_66 = { class: "fridgesettings-page-content-content-radiobutton-description-title" }
const _hoisted_67 = { class: "fridgesettings-page-content-content-radiobutton-description-title-text" }
const _hoisted_68 = { class: "fridgesettings-page-content-content-switch" }
const _hoisted_69 = { class: "fridgesettings-page-content-content-switch-description" }
const _hoisted_70 = { class: "fridgesettings-page-content-content-switch-description-title" }
const _hoisted_71 = { class: "fridgesettings-page-content-content-switch-description-title-text" }
const _hoisted_72 = /*#__PURE__*/_createVNode("img", {
  class: "fridgesettings-page-content-content-switch-description-button-image",
  src: _imports_0
}, null, -1)
const _hoisted_73 = { class: "fridgesettings-page-content-content-switch-description-note" }
const _hoisted_74 = { class: "fridgesettings-page-content-content-switch-description-note-text" }
const _hoisted_75 = { class: "fridgesettings-page-content-content-switch" }
const _hoisted_76 = { class: "fridgesettings-page-content-content-switch-description" }
const _hoisted_77 = { class: "fridgesettings-page-content-content-switch-description-title" }
const _hoisted_78 = { class: "fridgesettings-page-content-content-switch-description-title-text" }
const _hoisted_79 = {
  key: 5,
  class: "fridgesettings-page-content-content-quickbutton"
}
const _hoisted_80 = { class: "fridgesettings-page-content-content-quickbutton-top" }
const _hoisted_81 = { class: "fridgesettings-page-content-content-quickbutton-top-content" }
const _hoisted_82 = { class: "fridgesettings-page-content-content-quickbutton-top-content-title" }
const _hoisted_83 = { class: "fridgesettings-page-content-content-quickbutton-top-content-title-text" }
const _hoisted_84 = /*#__PURE__*/_createVNode("img", {
  class: "fridgesettings-page-content-content-quickbutton-top-content-button-image",
  src: _imports_0
}, null, -1)
const _hoisted_85 = { class: "fridgesettings-page-content-content-detailsettings" }
const _hoisted_86 = {
  key: 0,
  class: "fridgesettings-page-content-content-detailsettings-open"
}
const _hoisted_87 = { class: "fridgesettings-page-content-content-detailsettings-open-top" }
const _hoisted_88 = { class: "fridgesettings-page-content-content-detailsettings-open-top-content" }
const _hoisted_89 = { class: "fridgesettings-page-content-content-detailsettings-open-top-content-title" }
const _hoisted_90 = { class: "fridgesettings-page-content-content-detailsettings-open-top-content-title-text" }
const _hoisted_91 = /*#__PURE__*/_createVNode("img", {
  class: "fridgesettings-page-content-content-detailsettings-open-top-content-button-image",
  src: _imports_0
}, null, -1)
const _hoisted_92 = {
  key: 0,
  class: "fridgesettings-page-content-content-detailsettings-open-econavilamp"
}
const _hoisted_93 = { class: "fridgesettings-page-content-content-detailsettings-open-econavilamp-title" }
const _hoisted_94 = { class: "fridgesettings-page-content-content-detailsettings-open-econavilamp-title-text" }
const _hoisted_95 = {
  key: 1,
  class: "fridgesettings-page-content-content-radiobutton"
}
const _hoisted_96 = { class: "fridgesettings-page-content-content-radiobutton-description" }
const _hoisted_97 = { class: "fridgesettings-page-content-content-radiobutton-description-title" }
const _hoisted_98 = { class: "fridgesettings-page-content-content-radiobutton-description-title-text" }
const _hoisted_99 = { class: "fridgesettings-page-content-content-radiobutton" }
const _hoisted_100 = { class: "fridgesettings-page-content-content-radiobutton-description" }
const _hoisted_101 = { class: "fridgesettings-page-content-content-radiobutton-description-title" }
const _hoisted_102 = { class: "fridgesettings-page-content-content-radiobutton-description-title-text" }
const _hoisted_103 = { class: "fridgesettings-page-content-content-radiobutton" }
const _hoisted_104 = { class: "fridgesettings-page-content-content-radiobutton-description" }
const _hoisted_105 = { class: "fridgesettings-page-content-content-radiobutton-description-title" }
const _hoisted_106 = { class: "fridgesettings-page-content-content-radiobutton-description-title-text" }
const _hoisted_107 = {
  key: 2,
  class: "fridgesettings-page-content-content-radiobutton"
}
const _hoisted_108 = { class: "fridgesettings-page-content-content-radiobutton-description" }
const _hoisted_109 = { class: "fridgesettings-page-content-content-radiobutton-description-title" }
const _hoisted_110 = { class: "fridgesettings-page-content-content-radiobutton-description-title-text" }
const _hoisted_111 = { class: "fridgesettings-page-content-content-detailsettings-openclosebutton" }
const _hoisted_112 = { class: "fridgesettings-page-content-content-detailsettings-openclosebutton-content-title" }
const _hoisted_113 = { class: "fridgesettings-page-content-content-detailsettings-openclosebutton-content-title-text" }
const _hoisted_114 = {
  key: 1,
  class: "fridgesettings-page-bottom"
}
const _hoisted_115 = { class: "fridgesettings-page-bottom-initial" }
const _hoisted_116 = { class: "fridgesettings-page-bottom-initial-button-text" }
const _hoisted_117 = /*#__PURE__*/_createVNode("div", { class: "fridgesettings-page-bottom-top" }, null, -1)
const _hoisted_118 = { class: "fridgesettings-page-bottom-button" }
const _hoisted_119 = { class: "fridgesettings-page-bottom-button-button-text" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_FridgeDetailsRadioButton = _resolveComponent("FridgeDetailsRadioButton")
  const _component_CommonSwitch = _resolveComponent("CommonSwitch")
  const _component_FridgeSettingsQuickButtonItem = _resolveComponent("FridgeSettingsQuickButtonItem")
  const _component_FridgeDetailsConfirmSettingsDialog = _resolveComponent("FridgeDetailsConfirmSettingsDialog")
  const _component_CommonDesignDialog = _resolveComponent("CommonDesignDialog")
  const _component_FridgeDetailsSettingsHelpDialog = _resolveComponent("FridgeDetailsSettingsHelpDialog")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.isValidSettings)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            (_ctx.isValidPartialChilledChange)
              ? (_openBlock(), _createBlock("div", _hoisted_4, [
                  _createVNode("div", _hoisted_5, [
                    _createVNode("div", _hoisted_6, [
                      _createVNode("div", _hoisted_7, [
                        _createVNode("span", _hoisted_8, _toDisplayString(_ctx.partialChilledTitleText), 1)
                      ]),
                      _createVNode("div", {
                        class: "fridgesettings-page-content-content-partialchilled-change-title-button",
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.partialChilledChangeHelp(...args)))
                      }, [
                        _hoisted_9
                      ])
                    ]),
                    _createVNode("div", _hoisted_10, [
                      _createVNode(_component_FridgeDetailsRadioButton, {
                        key: _ctx.updateDisplayKey,
                        labels: _ctx.partialChilledRadioButtonLabels,
                        initialSelectIndex: _ctx.initialIndexPartialChilled,
                        onSelectChange: _ctx.partialChilledChange
                      }, null, 8, ["labels", "initialSelectIndex", "onSelectChange"])
                    ])
                  ]),
                  _createVNode("div", _hoisted_11, [
                    _createVNode("div", _hoisted_12, [
                      _createVNode("div", _hoisted_13, [
                        _createVNode("span", _hoisted_14, _toDisplayString(_ctx.partialText), 1)
                      ])
                    ]),
                    _createVNode(_component_FridgeDetailsRadioButton, {
                      class: "fridgesettings-page-content-content-radiobutton-three",
                      key: _ctx.updateDisplayKey,
                      labels: _ctx.strengthRadioButtonLabels,
                      initialSelectIndex: _ctx.initialIndexPartial,
                      isDisable: _ctx.settingsBuffer.partial_mode=='chilled',
                      onSelectChange: _ctx.partialChange
                    }, null, 8, ["labels", "initialSelectIndex", "isDisable", "onSelectChange"])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.isValidPartialHalf)
              ? (_openBlock(), _createBlock("div", _hoisted_15, [
                  _createVNode("div", _hoisted_16, [
                    _createVNode("div", _hoisted_17, [
                      _createVNode("span", _hoisted_18, _toDisplayString(_ctx.partialHalfTitleText), 1)
                    ]),
                    _createVNode("div", {
                      class: "fridgesettings-page-content-content-partialhalf-title-button",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.partialHalfHelp(...args)))
                    }, [
                      _hoisted_19
                    ])
                  ]),
                  _createVNode("div", _hoisted_20, [
                    _hoisted_21,
                    _createVNode("div", _hoisted_22, [
                      _createVNode("div", _hoisted_23, [
                        _createVNode("span", _hoisted_24, _toDisplayString(_ctx.partialHalf7hourTitleText), 1)
                      ]),
                      _createVNode("div", _hoisted_25, [
                        _createVNode("span", _hoisted_26, _toDisplayString(_ctx.partialHalf7hourSubTitleText), 1)
                      ]),
                      _createVNode("div", _hoisted_27, [
                        _createVNode(_component_CommonSwitch, {
                          class: "fridgesettings-page-content-content-switch-switch",
                          key: _ctx.updateDisplayKey,
                          initialState: _ctx.partialHalf7HourValue,
                          inhibit: _ctx.partialHalf7HourInhibit,
                          onChangeState: _ctx.changePartialHalf7Hour
                        }, null, 8, ["initialState", "inhibit", "onChangeState"])
                      ])
                    ]),
                    _hoisted_28,
                    _createVNode("div", _hoisted_29, [
                      _createVNode("div", _hoisted_30, [
                        _createVNode("span", _hoisted_31, _toDisplayString(_ctx.partialHalf5hourTitleText), 1)
                      ]),
                      _createVNode("div", _hoisted_32, [
                        _createVNode("span", _hoisted_33, _toDisplayString(_ctx.partialHalf5hourSubTitleText), 1)
                      ]),
                      _createVNode("div", _hoisted_34, [
                        _createVNode(_component_CommonSwitch, {
                          class: "fridgesettings-page-content-content-partialhalf-value-hour-switch-switch",
                          key: _ctx.updateDisplayKey,
                          initialState: _ctx.partialHalf5HourValue,
                          inhibit: _ctx.partialHalf5HourInhibit,
                          onChangeState: _ctx.changePartialHalf5Hour
                        }, null, 8, ["initialState", "inhibit", "onChangeState"])
                      ])
                    ]),
                    _hoisted_35
                  ])
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_36, [
              _createVNode("div", _hoisted_37, [
                _createVNode("div", _hoisted_38, [
                  _createVNode("span", _hoisted_39, _toDisplayString(_ctx.refrigerationText), 1)
                ]),
                _createVNode("div", {
                  class: "fridgesettings-page-content-content-radiobutton-description-button",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.refrigerationHelp(...args)))
                }, [
                  _hoisted_40
                ])
              ]),
              _createVNode(_component_FridgeDetailsRadioButton, {
                class: "fridgesettings-page-content-content-radiobutton-three",
                key: _ctx.updateDisplayKey,
                labels: _ctx.strengthRadioButtonLabels,
                initialSelectIndex: _ctx.initialIndexRefrigeration,
                onSelectChange: _ctx.refrigerationChange
              }, null, 8, ["labels", "initialSelectIndex", "onSelectChange"])
            ]),
            _createVNode("div", _hoisted_41, [
              _createVNode("div", _hoisted_42, [
                _createVNode("div", _hoisted_43, [
                  _createVNode("span", _hoisted_44, _toDisplayString(_ctx.frozenText), 1)
                ]),
                _createVNode("div", {
                  class: "fridgesettings-page-content-content-radiobutton-description-button",
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.frozenHelp(...args)))
                }, [
                  _hoisted_45
                ])
              ]),
              _createVNode(_component_FridgeDetailsRadioButton, {
                class: "fridgesettings-page-content-content-radiobutton-three",
                key: _ctx.updateDisplayKey,
                labels: _ctx.strengthRadioButtonLabels,
                initialSelectIndex: _ctx.initialIndexFrozen,
                onSelectChange: _ctx.frozenChange
              }, null, 8, ["labels", "initialSelectIndex", "onSelectChange"])
            ]),
            (_ctx.isValidFreshFrozen)
              ? (_openBlock(), _createBlock("div", _hoisted_46, [
                  _createVNode("div", _hoisted_47, [
                    _createVNode("div", _hoisted_48, [
                      _createVNode("span", _hoisted_49, _toDisplayString(_ctx.freshFrozenText), 1)
                    ]),
                    _createVNode("div", {
                      class: "fridgesettings-page-content-content-switch-description-button",
                      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.freshFrozenHelp(...args)))
                    }, [
                      _hoisted_50
                    ]),
                    _createVNode("div", _hoisted_51, [
                      _createVNode("span", _hoisted_52, _toDisplayString(_ctx.freshFrozenNoteText), 1)
                    ])
                  ]),
                  _createVNode(_component_CommonSwitch, {
                    class: "fridgesettings-page-content-content-switch-switch",
                    key: _ctx.updateDisplayKey,
                    initialState: _ctx.settingsBuffer.fresh_frozen_status,
                    onChangeState: _ctx.changeFreshFrozen
                  }, null, 8, ["initialState", "onChangeState"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.isValidPartialFrozenChange)
              ? (_openBlock(), _createBlock("div", _hoisted_53, [
                  _createVNode("div", _hoisted_54, [
                    _createVNode("div", _hoisted_55, [
                      _createVNode("div", _hoisted_56, [
                        _createVNode("span", _hoisted_57, _toDisplayString(_ctx.partialFrozenTitleText), 1)
                      ]),
                      _createVNode("div", {
                        class: "fridgesettings-page-content-content-partialfrozen-change-title-button",
                        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.partialFrozenModeHelp(...args)))
                      }, [
                        _hoisted_58
                      ])
                    ]),
                    _createVNode("div", _hoisted_59, [
                      _createVNode(_component_FridgeDetailsRadioButton, {
                        key: _ctx.updateDisplayKey,
                        labels: _ctx.partialFrozenRadioButtonLabels,
                        initialSelectIndex: _ctx.initialIndexPartialFrozen,
                        onSelectChange: _ctx.partialFrozenModeChange
                      }, null, 8, ["labels", "initialSelectIndex", "onSelectChange"])
                    ])
                  ]),
                  _createVNode("div", _hoisted_60, [
                    _createVNode("div", _hoisted_61, [
                      _createVNode("div", _hoisted_62, [
                        _createVNode("span", _hoisted_63, _toDisplayString(_ctx.partialFrozenStrengthText), 1)
                      ])
                    ]),
                    _createVNode(_component_FridgeDetailsRadioButton, {
                      class: "fridgesettings-page-content-content-radiobutton-three",
                      key: _ctx.updateDisplayKey,
                      labels: _ctx.strengthRadioButtonLabels,
                      initialSelectIndex: _ctx.initialIndexPartialFrozenStrength,
                      onSelectChange: _ctx.partailFrozenStrengthChange
                    }, null, 8, ["labels", "initialSelectIndex", "onSelectChange"])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.isValidCoolingAssistStrength)
              ? (_openBlock(), _createBlock("div", _hoisted_64, [
                  _createVNode("div", _hoisted_65, [
                    _createVNode("div", _hoisted_66, [
                      _createVNode("span", _hoisted_67, _toDisplayString(_ctx.coolingAssistRoomStrengthText), 1)
                    ])
                  ]),
                  _createVNode(_component_FridgeDetailsRadioButton, {
                    class: "fridgesettings-page-content-content-radiobutton-three",
                    key: _ctx.updateDisplayKey,
                    labels: _ctx.strengthRadioButtonLabels,
                    initialSelectIndex: _ctx.initialIndexCoolingAssistStrength,
                    onSelectChange: _ctx.coolongAssistStrengthChange
                  }, null, 8, ["labels", "initialSelectIndex", "onSelectChange"])
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_68, [
              _createVNode("div", _hoisted_69, [
                _createVNode("div", _hoisted_70, [
                  _createVNode("span", _hoisted_71, _toDisplayString(_ctx.quickIcingText), 1)
                ]),
                _createVNode("div", {
                  class: "fridgesettings-page-content-content-switch-description-button",
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.quickIcingHelp(...args)))
                }, [
                  _hoisted_72
                ]),
                _createVNode("div", _hoisted_73, [
                  _createVNode("span", _hoisted_74, _toDisplayString(_ctx.quickIcingNoteText), 1)
                ])
              ]),
              _createVNode(_component_CommonSwitch, {
                class: "fridgesettings-page-content-content-switch-switch",
                key: _ctx.updateDisplayKey,
                initialState: _ctx.settingsBuffer.fast_ice_status,
                onChangeState: _ctx.changeQuickIcing
              }, null, 8, ["initialState", "onChangeState"])
            ]),
            _createVNode("div", _hoisted_75, [
              _createVNode("div", _hoisted_76, [
                _createVNode("div", _hoisted_77, [
                  _createVNode("span", _hoisted_78, _toDisplayString(_ctx.stopIceMakingText), 1)
                ])
              ]),
              _createVNode(_component_CommonSwitch, {
                class: "fridgesettings-page-content-content-switch-switch",
                key: _ctx.updateDisplayKey,
                initialState: _ctx.settingsBuffer.stop_ice_status,
                onChangeState: _ctx.changeStopIce
              }, null, 8, ["initialState", "onChangeState"])
            ]),
            (_ctx.isValidQuickButton)
              ? (_openBlock(), _createBlock("div", _hoisted_79, [
                  _createVNode("div", _hoisted_80, [
                    _createVNode("div", _hoisted_81, [
                      _createVNode("div", _hoisted_82, [
                        _createVNode("span", _hoisted_83, _toDisplayString(_ctx.quickOperationButtontitleText), 1)
                      ]),
                      _createVNode("div", {
                        class: "fridgesettings-page-content-content-quickbutton-top-content-button",
                        onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.quickOperationButtonHelp(...args)))
                      }, [
                        _hoisted_84
                      ])
                    ])
                  ]),
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.quickButtonSettings, (item) => {
                    return (_openBlock(), _createBlock(_component_FridgeSettingsQuickButtonItem, {
                      key: item.mode,
                      mode: item.mode,
                      name: item.name,
                      minutes: item.minutes,
                      seconds: item.seconds,
                      onClickQuick: _ctx.clickQuick
                    }, null, 8, ["mode", "name", "minutes", "seconds", "onClickQuick"]))
                  }), 128 /* KEYED_FRAGMENT */))
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_85, [
              (_ctx.isDetailsOpen)
                ? (_openBlock(), _createBlock("div", _hoisted_86, [
                    _createVNode("div", _hoisted_87, [
                      _createVNode("div", _hoisted_88, [
                        _createVNode("div", _hoisted_89, [
                          _createVNode("span", _hoisted_90, _toDisplayString(_ctx.detailSettingTitleText), 1)
                        ]),
                        _createVNode("div", {
                          class: "fridgesettings-page-content-content-detailsettings-open-top-content-button",
                          onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.detailSettingHelp(...args)))
                        }, [
                          _hoisted_91
                        ])
                      ])
                    ]),
                    (_ctx.isValidEconaviLamp)
                      ? (_openBlock(), _createBlock("div", _hoisted_92, [
                          _createVNode("div", _hoisted_93, [
                            _createVNode("span", _hoisted_94, _toDisplayString(_ctx.econaviLampTitleText), 1)
                          ]),
                          _createVNode(_component_CommonSwitch, {
                            class: "fridgesettings-page-content-content-detailsettings-open-econavilamp-switch",
                            key: _ctx.updateDisplayKey,
                            initialState: _ctx.settingsBuffer.econavi_lamp_status,
                            onChangeState: _ctx.changeEconaviLamp
                          }, null, 8, ["initialState", "onChangeState"])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.isValidCoolingAssitsLamp)
                      ? (_openBlock(), _createBlock("div", _hoisted_95, [
                          _createVNode("div", _hoisted_96, [
                            _createVNode("div", _hoisted_97, [
                              _createVNode("span", _hoisted_98, _toDisplayString(_ctx.coolingAssistLampTitleText), 1)
                            ])
                          ]),
                          _createVNode(_component_FridgeDetailsRadioButton, {
                            class: "fridgesettings-page-content-content-radiobutton-three",
                            key: _ctx.updateDisplayKey,
                            labels: _ctx.brightnessRadioButtonLabels,
                            initialSelectIndex: _ctx.initialIndexCoolingAssistLamp,
                            onSelectChange: _ctx.coolingAssistLampChange
                          }, null, 8, ["labels", "initialSelectIndex", "onSelectChange"])
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode("div", _hoisted_99, [
                      _createVNode("div", _hoisted_100, [
                        _createVNode("div", _hoisted_101, [
                          _createVNode("span", _hoisted_102, _toDisplayString(_ctx.doorAlarmVolumeTitleText), 1)
                        ])
                      ]),
                      _createVNode(_component_FridgeDetailsRadioButton, {
                        class: "fridgesettings-page-content-content-radiobutton-two",
                        key: _ctx.updateDisplayKey,
                        labels: _ctx.volumeRadioButtonLabels,
                        initialSelectIndex: _ctx.initialIndexDoorAlarmVolume,
                        onSelectChange: _ctx.doorAlarmVolumeChange
                      }, null, 8, ["labels", "initialSelectIndex", "onSelectChange"])
                    ]),
                    _createVNode("div", _hoisted_103, [
                      _createVNode("div", _hoisted_104, [
                        _createVNode("div", _hoisted_105, [
                          _createVNode("span", _hoisted_106, _toDisplayString(_ctx.innerLampTitleText), 1)
                        ])
                      ]),
                      _createVNode(_component_FridgeDetailsRadioButton, {
                        class: "fridgesettings-page-content-content-radiobutton-three",
                        key: _ctx.updateDisplayKey,
                        labels: _ctx.brightnessRadioButtonLabels,
                        initialSelectIndex: _ctx.initialIndexInnerLamp,
                        onSelectChange: _ctx.innerLampChange
                      }, null, 8, ["labels", "initialSelectIndex", "onSelectChange"])
                    ]),
                    (_ctx.isValidPartialChilledRoomLamp)
                      ? (_openBlock(), _createBlock("div", _hoisted_107, [
                          _createVNode("div", _hoisted_108, [
                            _createVNode("div", _hoisted_109, [
                              _createVNode("span", _hoisted_110, _toDisplayString(_ctx.partialChilledLampTitleText), 1)
                            ])
                          ]),
                          _createVNode(_component_FridgeDetailsRadioButton, {
                            class: "fridgesettings-page-content-content-radiobutton-three",
                            key: _ctx.updateDisplayKey,
                            labels: _ctx.brightnessRadioButtonLabels,
                            initialSelectIndex: _ctx.initialIndexPartialChilledLamp,
                            onSelectChange: _ctx.partialChilledLampChange
                          }, null, 8, ["labels", "initialSelectIndex", "onSelectChange"])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              _createVNode("div", _hoisted_111, [
                _createVNode("div", {
                  class: "fridgesettings-page-content-content-detailsettings-openclosebutton-content",
                  onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.clickDetailsOpenClose(...args)))
                }, [
                  _createVNode("div", _hoisted_112, [
                    _createVNode("span", _hoisted_113, _toDisplayString(_ctx.detailsOpenCloseButtonText), 1)
                  ])
                ])
              ])
            ])
          ])
        ], 512))
      : _createCommentVNode("", true),
    (_ctx.isValidSettings)
      ? (_openBlock(), _createBlock("div", _hoisted_114, [
          _createVNode("div", _hoisted_115, [
            _createVNode("div", {
              class: "fridgesettings-page-bottom-initial-button",
              onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.initialButtonAction(...args)))
            }, [
              _createVNode("span", _hoisted_116, _toDisplayString(_ctx.initialButtonText), 1)
            ])
          ]),
          _hoisted_117,
          _createVNode("div", _hoisted_118, [
            _createVNode("div", {
              class: "fridgesettings-page-bottom-button-button",
              onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.sendButtonAction(...args)))
            }, [
              _createVNode("span", _hoisted_119, _toDisplayString(_ctx.sendButtonText), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_FridgeDetailsConfirmSettingsDialog, {
      isShowDialog: _ctx.isShowConfirm,
      displayTitle: _ctx.confirmTitle,
      displayItemList: _ctx.confirmItemList,
      displayQuickButtonItemList: _ctx.confirmQuickButtonItemList,
      displayAfterQuickButtonItemList: _ctx.confirmAfterQuickButtonItemList,
      isInitial: _ctx.confirmInitial,
      onClickCancel: _ctx.clickConfirmCancel,
      onClickSend: _ctx.clickConfirmSend
    }, null, 8, ["isShowDialog", "displayTitle", "displayItemList", "displayQuickButtonItemList", "displayAfterQuickButtonItemList", "isInitial", "onClickCancel", "onClickSend"]),
    _createVNode(_component_CommonDesignDialog, {
      isShowDialog: _ctx.isShowCaution,
      dialogType: _ctx.cautionDialogType,
      title: _ctx.cautionDialogTitle,
      message: _ctx.cautionDialogMessage,
      mainImage: _ctx.cautionImage,
      messageAlign: _ctx.cautionMessageAlign,
      negativeLabel: _ctx.cautionDialogCancelTitle,
      positiveLabel: _ctx.cautionDialogOKButtonTitle,
      onNegativeClick: _ctx.cautionDialogCancelHandler,
      onPositiveClick: _ctx.cautionDialogOKHandler
    }, null, 8, ["isShowDialog", "dialogType", "title", "message", "mainImage", "messageAlign", "negativeLabel", "positiveLabel", "onNegativeClick", "onPositiveClick"]),
    _createVNode(_component_FridgeDetailsSettingsHelpDialog, {
      isShowDialog: _ctx.isShowHelp,
      contentsType: _ctx.helpType,
      productCode: _ctx.productCode,
      onClickClose: _ctx.closeButtonHandler
    }, null, 8, ["isShowDialog", "contentsType", "productCode", "onClickClose"]),
    _createVNode(_component_CommonDesignDialog, {
      isShowDialog: _ctx.isShowCompletion,
      dialogType: _ctx.completionDialogType,
      title: _ctx.completionDialogTitle,
      message: _ctx.completionDialogMessage,
      negativeLabel: _ctx.completionDialogButtonTitle,
      onNegativeClick: _ctx.completionCloseButtonHandler
    }, null, 8, ["isShowDialog", "dialogType", "title", "message", "negativeLabel", "onNegativeClick"]),
    _createVNode(_component_CommonDesignDialog, {
      isShowDialog: !!_ctx.handleApiError,
      dialogType: _ctx.typeApiError,
      title: _ctx.apiErrorTitle,
      message: _ctx.getApiErrorMessage,
      positiveLabel: _ctx.retryButtonTitle,
      negativeLabel: _ctx.okButtonTitle,
      onPositiveClick: _ctx.retryApiErrorHandler,
      onNegativeClick: _ctx.okApiErrorHandler
    }, null, 8, ["isShowDialog", "dialogType", "title", "message", "positiveLabel", "negativeLabel", "onPositiveClick", "onNegativeClick"])
  ]))
})